
import * as _ from 'underscore';
import * as angular from 'angular';
import { IApiService } from '../models/IApiService';
import { HttpService } from '../../api/http.service';
import { DefinitionsService } from './definitions.service';

export class WysiwygServiceComponent {
    allowCustomSelect: boolean;
    dataSource = {
        carousel: {
            script: {
                slick: `${this.apiService.getSiteAddressUrl()}scripts/vendor/slick/slick.min.js`,
                jquery: `${this.apiService.getSiteAddressUrl()}scripts/vendor/slick/jquery.js`,
                start: `${this.apiService.getSiteAddressUrl()}scripts/vendor/slick/carousel.start.js`,
            },
            stylesheet: `${this.apiService.getSiteAddressUrl()}scripts/vendor/slick/slick.css`,
        }
    };
    taToolbar = {
        insertLink: 'insertLink',
        insertImage: 'insertImage'
    };
    private insertedTokens: string[] = []; // images tokens was inserted in ui side
    private deleteTokens: string[] = [];  // images tokens of server side if there was deleted in ui

    constructor(
        private http: HttpService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private apiService: IApiService,
        private definitionsService: DefinitionsService,
        allowCustomSelect: boolean
    ) {
        this.allowCustomSelect = allowCustomSelect;
    }

    getInsertedTokens() {
        return this.insertedTokens;
    }

    deleteRemovedTokens(str: string) {
        let tokens = this.getImageTokensFromString(str);
        this.insertedTokens = _.reject(this.insertedTokens, (inserted) => {
            return _.contains(tokens, inserted);
        });
        _.forEach(this.deleteTokens, async (token) => {
            try {
                await this.deleteImage(token);
            } catch (error) {
                console.warn('wysiwygService.removeImage', error);
            }

        });
        this.deleteTokens = [];
    }

    getImageToken($element: HTMLImageElement): string {
        return ($element && _.isEmpty($element.src)) ? null : _.first($element.src.match(this.definitionsService.regexGuid));
    }

    async deleteImage(token: string) {
        return this.http.delete(this.apiService.wysiwygImage(token));
    }

    removeExcessTokens = () => {
        _.forEach(this.insertedTokens,
            async (token) => {
                try {
                    await this.deleteImage(token);
                } catch (error) {
                    console.warn('wysiwygService.removeImage', error);
                }
            });
    }

    copyHtmlContent = async (html: string) => {
        let tokens = this.getImageTokensFromString(html);
        if (_.isEmpty(tokens)) {
            return html;
        } else {
            try {
                let dictionary = await this.http.post<string[]>(this.apiService.wysiwygImageCopy(), tokens);
                _.forEach(dictionary, (token) => {
                    let copytoken = dictionary[token];
                    if (copytoken) {
                        html = html.replace(token, copytoken);
                        this.insertedTokens.push(copytoken);
                    } else {
                        var expression = `<img[^\>]*${token}[^\>]*>`;
                        var regex = new RegExp(expression, 'i');
                        html = html.replace(regex, copytoken);
                    }
                });
                return html;
            } catch (error) {
                return html.replace(this.definitionsService.regexImg, '');
            }
        }
    }

    getImageTokensFromString(str: string) {
        let html = $.parseHTML(str);
        let tokens = _.map($(html).find('img'), ($element: HTMLImageElement) => {
            return this.getImageToken($element);
        });
        return tokens ? tokens : [];
    }

    private insertImage() {
        return this.$uibModal.open({
            component: 'wysiwygInsertImage',
            resolve: {
                insertedTokens: () => this.insertedTokens,
                apiService: () => this.apiService
            },
            size: 'md',
        }).result;
    }

    private removeImage = async ($element: HTMLImageElement) => {
        var token = this.getImageToken($element);

        if (!_.isEmpty(token) && !_.contains(this.insertedTokens, token)) {
            this.deleteTokens.push(token);
        } else {
            try {
                await this.http.delete(this.apiService.wysiwygImage(token));
                this.insertedTokens = _.reject(this.insertedTokens, (items) => {
                    return items === token;
                });
            } catch (error) {
                console.warn('wysiwygService.removeImage', error);
            }
        }
    }

    private carousel(images: string[]) {
        return this.$uibModal.open({
            component: 'wysiwygCarousel',
            resolve: {
                images: () => {
                    return images ? images : [];
                },
                dataSource: () => {
                    return this.dataSource.carousel;
                }
            },
            size: 'lg',
        }).result;

    }
}

export class WysiwygService {
    static $inject = ['http', '$uibModal', 'retailerService', 'definitionsService'];
    constructor(
        private http: HttpService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private apiService: IApiService,
        private definitionsService: DefinitionsService
    ) {

    }

    instance(allowCustomSelect: boolean = false) {
        return new WysiwygServiceComponent(this.http, this.$uibModal, this.apiService, this.definitionsService, allowCustomSelect);
    }
}

angular.module('app.common')
    .service('wysiwygService', WysiwygService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/wysiwyg.service.ts